module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4b79b64e593be0d5e8701ff5a2ea6f66.gif";